// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================
   COHORT PAGE LAYOUT
   =============================== */

.cohort-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
}

/* ===============================
   CHAT WINDOW (SCROLLS)
   =============================== */

.chat-window {
  flex: 1 1;
  overflow-y: auto; /* ✅ chat scroll only */
  padding-right: 8px;
}

/* Chat bubble */
.chat-bubble {
  max-width: 70%;
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 8px;
  font-size: 14px;
}

.chat-bubble.user {
  background: #2563eb;
  color: #ffffff;
  margin-left: auto;
}

/* System messages */
.chat-bubble.system {
  background: #e5e7eb;
  color: #111827;
}

/* View details link */
.link {
  margin-top: 6px;
  font-size: 13px;
  color: #2563eb;
  cursor: pointer;
  text-decoration: underline;
}

.link:hover {
  color: #1d4ed8;
}

/* ===============================
   CHAT INPUT (FIXED AT BOTTOM)
   =============================== */

.chat-input {
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
}

/* Textarea */
.chat-input textarea {
  flex: 1 1;
  resize: none;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  font-size: 14px;
  outline: none;
}

.chat-input textarea:focus {
  border-color: #2563eb;
}

/* Send button */
.chat-input button {
  width: 80px;
  background: #2563eb;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

.chat-input button:hover {
  background: #1d4ed8;
}
.system-prompt {
  margin-bottom: 6px;
  font-size: 14px;
  color: #374151;
  line-height: 1.4;
}
.prompt-box {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 8px;

  display: flex;
  align-items: flex-start;
  gap: 6px;

  font-size: 13px;
  line-height: 1.4;
}

.prompt-label {
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

.prompt-text {
  color: #1f2937;
  word-break: break-word;
}

/* ===============================
   Details modal
   =============================== */
/* MODAL OVERLAY */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* MODAL BOX */
.modal-box {
  background: #ffffff;
  width: 85%;
  max-width: 900px;
  max-height: 85vh;
  overflow-y: auto;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
  animation: fadeIn 0.2s ease-in-out;
}

/* HEADINGS */
.modal-box h3 {
  margin-top: 0;
  margin-bottom: 16px;
}

.modal-box h4 {
  margin-top: 20px;
  margin-bottom: 8px;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
}

/* SQL BLOCK */
.modal-box pre {
  background: #f4f6f8;
  padding: 12px;
  border-radius: 6px;
  font-size: 13px;
  overflow-x: auto;
}

/* CLOSE BUTTON */
.modal-box button {
  margin-top: 20px;
  padding: 8px 16px;
  border: none;
  background: #2563eb;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
}

.modal-box button:hover {
  opacity: 0.9;
}

/* SMALL ANIMATION */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.97);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* HEADER */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-close {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

/* MULTI COLUMN DISTRIBUTION */
.distribution-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  font-size: 14px;
}

`, "",{"version":3,"sources":["webpack://./src/styles/cohort.css"],"names":[],"mappings":"AAAA;;oCAEoC;;AAEpC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;oCAEoC;;AAEpC;EACE,SAAO;EACP,gBAAgB,EAAE,uBAAuB;EACzC,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;oCAEoC;;AAEpC;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;;EAElB,aAAa;EACb,uBAAuB;EACvB,QAAQ;;EAER,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;oCAEoC;AACpC,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;AACjB","sourcesContent":["/* ===============================\n   COHORT PAGE LAYOUT\n   =============================== */\n\n.cohort-page {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n/* ===============================\n   CHAT WINDOW (SCROLLS)\n   =============================== */\n\n.chat-window {\n  flex: 1;\n  overflow-y: auto; /* ✅ chat scroll only */\n  padding-right: 8px;\n}\n\n/* Chat bubble */\n.chat-bubble {\n  max-width: 70%;\n  padding: 12px;\n  margin-bottom: 12px;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.chat-bubble.user {\n  background: #2563eb;\n  color: #ffffff;\n  margin-left: auto;\n}\n\n/* System messages */\n.chat-bubble.system {\n  background: #e5e7eb;\n  color: #111827;\n}\n\n/* View details link */\n.link {\n  margin-top: 6px;\n  font-size: 13px;\n  color: #2563eb;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.link:hover {\n  color: #1d4ed8;\n}\n\n/* ===============================\n   CHAT INPUT (FIXED AT BOTTOM)\n   =============================== */\n\n.chat-input {\n  display: flex;\n  gap: 8px;\n  padding: 12px;\n  border-top: 1px solid #e5e7eb;\n  background: #ffffff;\n}\n\n/* Textarea */\n.chat-input textarea {\n  flex: 1;\n  resize: none;\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid #cbd5e1;\n  font-size: 14px;\n  outline: none;\n}\n\n.chat-input textarea:focus {\n  border-color: #2563eb;\n}\n\n/* Send button */\n.chat-input button {\n  width: 80px;\n  background: #2563eb;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.chat-input button:hover {\n  background: #1d4ed8;\n}\n.system-prompt {\n  margin-bottom: 6px;\n  font-size: 14px;\n  color: #374151;\n  line-height: 1.4;\n}\n.prompt-box {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 8px 12px;\n  margin-bottom: 8px;\n\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.prompt-label {\n  font-weight: 600;\n  color: #374151;\n  white-space: nowrap;\n}\n\n.prompt-text {\n  color: #1f2937;\n  word-break: break-word;\n}\n\n/* ===============================\n   Details modal\n   =============================== */\n/* MODAL OVERLAY */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n/* MODAL BOX */\n.modal-box {\n  background: #ffffff;\n  width: 85%;\n  max-width: 900px;\n  max-height: 85vh;\n  overflow-y: auto;\n  border-radius: 10px;\n  padding: 24px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n/* HEADINGS */\n.modal-box h3 {\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n\n.modal-box h4 {\n  margin-top: 20px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 4px;\n}\n\n/* SQL BLOCK */\n.modal-box pre {\n  background: #f4f6f8;\n  padding: 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  overflow-x: auto;\n}\n\n/* CLOSE BUTTON */\n.modal-box button {\n  margin-top: 20px;\n  padding: 8px 16px;\n  border: none;\n  background: #2563eb;\n  color: #fff;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.modal-box button:hover {\n  opacity: 0.9;\n}\n\n/* SMALL ANIMATION */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* HEADER */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-close {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n/* MULTI COLUMN DISTRIBUTION */\n.distribution-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  font-size: 14px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
